export default __webpack_public_path__ + "static/lavora-con-noi-astrorei-3278e026aa2f49eb455de673573c3959.jpg";